import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import { IBaseFilterBrokerRank } from "./BrokerRankIndex";

export function filterByDV01(
  data: IBaseAnalyticsCombined[],
  dataFilters: IBaseFilterBrokerRank,
) {
  const { DV01BucketsKeys } = dataFilters;

  // If there's no valid range, return the original data
  if (!DV01BucketsKeys) {
    return data;
  } else if (DV01BucketsKeys.length == 0) {
    return [];
  }

  return data.filter((obj: any) => {
    return DV01BucketsKeys.includes(obj.DV01Buckets);
  });
}

// Colour gradient return
export function interpolateColorRankSpecific(
  color1: string,
  color2: string,
  value: number, // between 0 and 100
  paramsData: any,
): string {
  // Clamp to [0, 100] // MUST have the value x 100 as it's coming in as a decimal.
  let totalOptions = 0;
  for (const key in paramsData) {
    if (Object.prototype.hasOwnProperty.call(paramsData, key)) {
      totalOptions += 1;
    }
  }

  const v = Math.max(1, Math.min(value, totalOptions));

  // Factor goes from 0 (at 100) to 1 (at 0)
  const factor = (v - 1) / (totalOptions - 1);

  const c1 = parseInt(color1.slice(1), 16);
  const c2 = parseInt(color2.slice(1), 16);

  const r1 = (c1 >> 16) & 0xff,
    g1 = (c1 >> 8) & 0xff,
    b1 = c1 & 0xff;
  const r2 = (c2 >> 16) & 0xff,
    g2 = (c2 >> 8) & 0xff,
    b2 = c2 & 0xff;

  const r = Math.round(r1 + (r2 - r1) * factor);
  const g = Math.round(g1 + (g2 - g1) * factor);
  const b = Math.round(b1 + (b2 - b1) * factor);

  // return rgb string
  return `rgb(${r}, ${g}, ${b})`;
}

export function interpolateColor(
  color1: string,
  color2: string,
  factor: number,
): string {
  const c1 = parseInt(color1.slice(1), 16);
  const c2 = parseInt(color2.slice(1), 16);

  const r1 = (c1 >> 16) & 0xff,
    g1 = (c1 >> 8) & 0xff,
    b1 = c1 & 0xff;
  const r2 = (c2 >> 16) & 0xff,
    g2 = (c2 >> 8) & 0xff,
    b2 = c2 & 0xff;

  const r = Math.round(r1 + (r2 - r1) * factor);
  const g = Math.round(g1 + (g2 - g1) * factor);
  const b = Math.round(b1 + (b2 - b1) * factor);

  return `rgb(${r}, ${g}, ${b})`;
}

export function insertSorted(arr: any[], newItem: any): void {
  const index = arr.findIndex((item) => item.value > newItem.value);
  if (index === -1) {
    arr.push(newItem); // goes at end
  } else {
    arr.splice(index, 0, newItem); // insert at found index
  }
}
